module.exports = __webpack_public_path__ + "media/images/badge-d14025b13919e04bc1f7ecbd3b02b74c.png";